import { API_BASE_URL } from "@/libs/apis/commons";

export const ORDER_DETAIL_URL = (orderId: string) =>
  `${API_BASE_URL}/orders/${orderId}`;

export const ORDER_DETAIL_URL_WITH_CONTENTFUL = (orderId: string) =>
  `${ORDER_DETAIL_URL(orderId)}?includeContentful=true`;

export const errorText =
  "Something went wrong. Connect with our support team for assistance.";

export const ORDER_CONFIRMATION_HEADER = "Your order is confirmed";
export const ORDER_CONFIRMATION_SUBHEAD =
  "We're processing your order and will send you an email when it's ready.";

export const ORDER_NUMBER_TEST_ID = "orderConfirmation_orderNumber";
export const PRODUCT_NAME_TEST_ID = "orderConfirmation_productName";
export const PRODUCT_PRICE_TEST_ID = "orderConfirmation_productPrice";
export const ORDER_QUANTITY_TEST_ID = "orderConfirmation_orderQuantity";
export const ORDER_SUBTOTAL_TEST_ID = "orderConfirmation_orderSubtotal";
export const ORDER_TAX_TEST_ID = "orderConfirmation_orderTax";
export const ORDER_TOTAL_TEST_ID = "orderConfirmation_orderTotal";
